import { render, staticRenderFns } from "./Welcome_HaiNan.vue?vue&type=template&id=011f251f&scoped=true&"
import script from "./Welcome_HaiNan.vue?vue&type=script&lang=js&"
export * from "./Welcome_HaiNan.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_HaiNan.vue?vue&type=style&index=0&id=011f251f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f251f",
  null
  
)

export default component.exports